
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/folder/[folder]",
      function () {
        return require("private-next-pages/folder/[folder].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/folder/[folder]"])
      });
    }
  